import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuthenticator } from '@aws-amplify/ui-react';
import { WORKSPACE } from 'constants/paths';

import { IUnauthorizedRouteProps } from './types';

export const UnauthorizedRoute: React.FC<IUnauthorizedRouteProps> = ({ children = <Outlet /> }) => {
  const { authStatus } = useAuthenticator((context) => [context.user, context.route]);

  if (authStatus === 'authenticated') {
    return <Navigate to={WORKSPACE} replace />;
  }

  return <>{children}</>;
};
